import React, { useContext, useEffect, useState } from 'react'
import * as api from '@/apis/aipass'
import { Dayjs } from 'dayjs'
import { SearchReservationEachRoom } from '@/models/reservation'
import { LoaderContextCreator } from '@/contexts/loader'
import { ReservationRoomSelectorModal } from '@/components/molecules/reservation-room-selector-modal'
import { useErrorHandler } from '@/hooks/use-error-handler'

interface Props {
  transactionId: string
  usageDay: Dayjs
  onCancel: () => void
  onSubmit: () => void
}
export const TransactionLinkModal: React.FC<Props> = props => {
  const { errorHandler } = useErrorHandler()
  const { setIsLoading } = useContext(LoaderContextCreator())
  const [searchReservations, setSearchReservations] = useState<SearchReservationEachRoom[]>([])

  const doSearch = async () => {
    setIsLoading(true)
    const reservations = await api.getLinkedReservationsBySmaregi()
    setSearchReservations(reservations)
    setIsLoading(false)
  }

  const onSubmitSmaregiLinkRoom = async (value: SearchReservationEachRoom) => {
    try {
      setIsLoading(true)
      await api.putSmaregiTransactionLinkReservation(props.transactionId, value)
      props.onSubmit()
    } catch (e) {
      errorHandler(e)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    doSearch()
  }, [])

  return <ReservationRoomSelectorModal reservations={searchReservations} onCancel={props.onCancel} onSubmit={onSubmitSmaregiLinkRoom} />
}
